import AntLayout from 'antd/lib/layout';

const { Content: AntContent } = AntLayout;

export const Layout = AntLayout;

export const Content = AntContent;
